// Note: This is only for routes the FE needs to inteact with via AJAX
//       All other routes are automatically generated by Rails and
//       manually included via the generate_js_routes rake task
export default {
  orderGroupsOverviewPath() {
    return `/api/startups/me/order_groups`;
  },
  orderGroupsOverviewAllPath() {
    return `/api/startups/me/order_groups?all=1`;
  },
  orderUnitsOverviewPath() {
    return `/api/startups/order_units`;
  },
  orderUnitDetailsPath(id) {
    return `/api/startups/order_units/${id}`;
  },
  orderUnitEditPath(id) {
    return `/api/startups/order_units/${id}/edit`;
  },
  updateOrderUnitPath(id) {
    return `/api/startups/order_units/${id}`;
  },
  updateOrderUnitProductsPath(id) {
    return `/api/startups/order_units/${id}/products`;
  },
  createOrderUnitPath() {
    return `/api/startups/order_units`;
  },
  orderUnitApprovalPath(id) {
    return `/api/startups/order_units/${id}/request_approval`;
  },
  externalOrdersPath() {
    return `/api/startups/external_orders`;
  },
  externalOrdersAllPath() {
    return `/api/startups/external_orders?all=1`;
  },
  externalOrderPath(id) {
    return `/api/startups/external_orders/${id}`;
  },
  meProductsPath() {
    return `/api/startups/me/products`;
  },
  uploadPresignPath() {
    return `/uploads/presign`;
  },
};
